import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from './url-helper.service';
import { BooleanResult } from '../interfaces/boolean-result.interface';

@Injectable()
export class DetailService<TEntity> {

  constructor(private http: HttpClient,
              private urlService: UrlHelperService) {}

  byId(apiController: string, id: string): Observable<any> {
    var url = this.buildUrl(apiController, id);
    return this.http.get<TEntity>(url);
  }

  checkIdByOrgagnization(id: string) {

  }

  save(entity: TEntity, apiController: string, id: string | null, showLoadingOverlay: boolean = true): Observable<BooleanResult> {

    var url = this.urlService.getApiUrl() + apiController + "/" + id;

    return this.http.post<BooleanResult>(url, entity);
  }

  private buildUrl(apiController: string, id: string): string {
    return this.urlService.getApiUrl() + apiController + "/" + id;
  }

  remove(id: string, apiController: string): Observable<BooleanResult> {
    var url = this.urlService.getApiUrl() + apiController + "/" + id;
    return this.http.delete<BooleanResult>(url);
  }

}
